export const registerDocSizeListener = () => {
  const handler = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--doc-height", `${window.innerHeight}px`);
  };

  window.addEventListener("resize", handler);
  handler();
};
